import LogoB from '../../../public/svg_images/logo_b.svg';

function LogoBSvg() {
  return (
    <div>
    <LogoB
      width={74}
      height={74}
      aria-hidden="true" 
    />
    </div>
  );
}

export default LogoBSvg;